<template>
<v-text-field
  :value="value"
  :loading="loading"
  dense
  outlined
  :class="(type == 'number') ? 'ec-font-size16 right-input' : 'ec-font-size16'"
  :hide-details="!error"
  :rules="validate"
  :error-messages="errors"
  :placeholder="placeholder"
  :type="type"
  :label="label"
  :disabled="(disabled == true)"
  background-color="rgba(var(--b3f,250,250,250),1)"
  :prefix="prefix"
  :suffix="suffix"
  :inputmode="(type == 'number') ? 'numeric' : ''"
  @input="updateValue"
></v-text-field>
</template>
<script>
import ValidationLib from '@/libs/ValidationLib'

export default {
  name: 'ComponentsItemsTextFieldCustomType',

  data () {
    return {
      validate: [],
      placeholder: '',
      error: false,
      errors: ''
    }
  },

  computed: {
  },

  created: function () {
    this.validate = ValidationLib.rules(this.name)
    this.placeholder = ValidationLib.placeholder(this.name)
  },

  methods: {
    updateValue: function (e) {
      this.$emit('update:value', e)
    },

    isError: function () {
      return (this.errors.length > 0)
    },

    setError: function (message) {
      this.errors = message
      this.error = true
    },

    confirm: function () {
      return new Promise((resolve, reject) => {
        try {
          this.errors = ''
          for (var y = 0; y < this.validate.length; y++) {
            const err = this.validate[y](this.value)
            if (err !== true) {
              this.errors = err
              break
            }
          }
          if (this.isError()) {
            this.error = true
            return resolve(false)
          }
          this.error = false
          return resolve(true)
        } catch (e) {
          return reject(e)
        }
      })
    }
  },

  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true,
      default: () => ''
    },
    type: {
      type: String,
      required: true,
      default: () => 'text'
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    loading: {
      type: Boolean,
      required: false,
      default: () => false
    },
    prefix: {
      type: String,
      required: false,
      // default: () => '\\'
      default: () => ''
    },
    suffix: {
      type: String,
      required: false,
      // default: () => '円'
      default: () => ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    }
  }
}
</script>
